import * as React  from 'react'
import { connect } from 'react-redux'

import Button           from '@material-ui/core/Button'
import Grid             from '@material-ui/core/Grid'
import Hidden           from '@material-ui/core/Hidden'
import FileDownloadIcon from '@material-ui/icons/FileDownload'

import { AccountType, AccountTypeInvitation, User }         from '../../api'
import { api }                                              from '../../client'
import { communicationToUiState }                           from '../../project-utils'
import { genSelectByType, inviteUserRequest, usersRequest } from '../../redux'
import { isPresentInAnyOf }                                 from '../../utils'
import { ActionButton, SearchField }                        from '../atoms'
import { FormikSubmissionCallBack }                         from '../forms/types'
import InviteUserForm, { InviteUserFields }                 from '../forms/UserInviteForm'
import loadable                                             from '../hocs/loadable'
import withValue, { InjectedValueProps }                    from '../hocs/withValue'
import { ActiveStatusFilterControls, UserList }             from '../molecules'
import DownloadExport                                       from '../organisms/DownloadExport'

interface UsersProps {
  accountType: AccountType
}

type Props =
  UsersProps
  & typeof actions
  & ReturnType<typeof mstp>
  & InjectedValueProps

const mstp = (state, passedProps: UsersProps) => ({
  users:                   genSelectByType(passedProps.accountType)(state),
  inviteUserCommunication: inviteUserRequest.communicationSelector(state),
  getUsersCommunication:   usersRequest.communicationSelector(state),
})

const actions = {
  inviteUser:      inviteUserRequest.actionCreator,
  resetInviteUser: inviteUserRequest.resetActionCreator,

  getUsers: usersRequest.actionCreator,
}

interface State {
  displayByActive: boolean
}

class Users extends React.Component<Props, State> {
  public state = {
    displayByActive: true
  }

  private readonly exportRequest = api.exportUsers(String(this.props.accountType))

  private userList = loadable(
    ({ users }: { users: User [] }
    ) => (
      <UserList
        accountType={this.props.accountType}
        users={users}
      />
    )
  )

  public componentDidMount () {
    /*
     TODO: change api-spec

     required param is string but it should an AccountType-enum value
     */
    this.props.getUsers(String(this.props.accountType))
  }

  public componentWillUnmount () {
    this.props.resetInviteUser()
  }

  public render () {
    return (
      <Grid
        container
        direction={'column'}
        spacing={16}
      >
        <Grid item>
          {this.renderCreateMentorForm()}
        </Grid>
        <Grid item>
          {this.renderControlsBar()}
        </Grid>
        <Grid item>
          {this.renderSearchBar()}
        </Grid>
        <Grid item>
          {this.renderUserList()}
        </Grid>
      </Grid>
    )
  }

  private renderControlsBar = () => {
    return (
      <Grid
        container
        justify={'flex-end'}
        alignItems={'center'}
        spacing={16}
      >
        <Grid item>
          <ActiveStatusFilterControls
            active={this.state.displayByActive}
            setActiveFilter={this.setActiveFilter}
          />
        </Grid>
        <Grid item>
          <DownloadExport
            fileName={'users.xlsx'}
            fileRequest={this.exportRequest}
          >
            {({ loaded }) => (
              <>
                <Hidden xsDown>
                  <ActionButton
                    disabled={!loaded}
                    color={'secondary'}
                    actionType={'download'}
                    variant={'raised'}
                  />
                </Hidden>
                <Hidden smUp>
                  <Button
                    disabled={!loaded}
                    color={'secondary'}
                    variant={'raised'}
                  >
                    <FileDownloadIcon />
                  </Button>
                </Hidden>
              </>
            )}
          </DownloadExport>
        </Grid>
      </Grid>
    )
  }

  private renderCreateMentorForm = () => (
    <InviteUserForm
      accountType={this.props.accountType}
      onSubmit={this.invite}
      {...this.props.inviteUserCommunication}
    />
  )

  private renderSearchBar = () => {
    return (
      <SearchField
        onChange={this.props.handleChange}
        value={this.props.value || ''}
      />
    )
  }

  private renderUserList = () => {
    const UserList = this.userList
    const usersUiState = communicationToUiState(this.props.getUsersCommunication)
    const users = this.getDisplayedUsers()

    return (
      <UserList
        ui={usersUiState}
        users={users}
        isCached={!!this.props.users.length}
      />
    )
  }

  private invite: FormikSubmissionCallBack<InviteUserFields> = ({ email }) => {
    /*
     inviteUser wants a value from the AccountTypeInvitation enum so we're
     mapping the accountType from props to its equivalent AccountTypeInvitation
     */
    const type = AccountTypeInvitation[ AccountType[ this.props.accountType ] ]
    this.props.inviteUser({ email, type, })
  }

  private setActiveFilter = (active: boolean) => {
    this.setState({
      displayByActive: active,
    })
  }

  private getDisplayedUsers = () =>
    this.props.users.filter(this.deriveUserDisplayProp)

  private deriveUserDisplayProp = (user: User) => {
    const { value = '' } = this.props
    const { account: { active } } = user

    const matchesActiveFilter = this.state.displayByActive === active

    if (!matchesActiveFilter) return false

    if (active && user.personal && user.account) {
      const {
        personal: { name, surname },
        account:  { email },
      } = user

      return isPresentInAnyOf(
        value,
        [
          `${name} ${surname}`,
          `${surname} ${name}`,
          email,
        ]
      )
    }

    const { account: { email } } = user

    return isPresentInAnyOf(
      value,
      [
        email,
      ]
    )
  }
}

export default connect(mstp, actions)(withValue(Users))



// WEBPACK FOOTER //
// ./src/components/environments/Users.tsx